import css from './CheckedItemInfoMobile.module.css';
import { useState } from 'react';
import CheckboxInput from '@shared/Ui/CustomInputs/CheckboxInput/CheckboxInput';
import { CheckedItem } from '@modules/Steps/Shared/Interfaces/CheckedItem';
import DropdownButton from '@shared/Ui/Buttons/DropdownButton/DropdownButton';
import { ItemsSelectionViewModel } from '@viewModels/ItemsSelectionViewModel/ItemsSelectionViewModel';
import { useItemsSelectionStore } from '../../../../../../../Stores/ItemsSelectionStore';
import { IsItemSelected } from '@viewModels/ItemsSelectionViewModel/Services/IsItemSelected';
import { GetItemUnit } from '@modules/Steps/Shared/Helpers/GetItemUnit';

interface ItemTypeInfoMobileProps {
    item: CheckedItem;
}

export const CheckedItemInfoMobile: React.FC<ItemTypeInfoMobileProps> = ({
    item,
}) => {
    const { title, qty, price, uuid } = item.item;

    const { selectedItems } = useItemsSelectionStore();

    const selectedItemsViewModel = new ItemsSelectionViewModel();

    const handleToggleSelectItem = () => {
        selectedItemsViewModel.toggleSelectItem(item.item);
    };

    const [expanded, setExpanded] = useState(false);
    const handleToggleExpanded = () => {
        setExpanded(prev => !prev);
    };

    const total = typeof qty === 'number' ? qty * Number(price) : Number(price);

    const isSelected = IsItemSelected(uuid, selectedItems);

    return (
        <div className={css.itemContainer}>
            <div className={css.item}>
                <div className={css.itemName}>
                    <div>{title}</div>
                </div>

                <div className={css.btns}>
                    <CheckboxInput
                        checked={isSelected}
                        onChange={handleToggleSelectItem}
                        disabled={item.isLabour}
                    />

                    <DropdownButton
                        onClick={handleToggleExpanded}
                        isOpen={expanded}
                        extraClassName={css.dropdownBtn}
                    />
                </div>
            </div>
            <div className={`${css.itemsList} ${expanded ? css.show : ''}`}>
                <div className={css.checkedItemType}>
                    <span>Calculated QTY</span>
                    <span className={css.checkedItemValue}>
                        {GetItemUnit(item.item)}
                    </span>
                </div>
                <div className={css.checkedItemType}>
                    <span>Unit price</span>
                    <span className={css.checkedItemValue}>
                        <span>R {price?.toFixed(2)}</span>
                    </span>
                </div>
                <div className={css.checkedItemType}>
                    <span>Total</span>
                    <span className={css.checkedItemValue}>
                        R {total.toFixed(2)}
                    </span>
                </div>
            </div>
        </div>
    );
};
